import { useState } from "react";
import { deleteAccount, sendOTPForDelete, verifyOTPForDelete } from "./services/Api";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

const AccountDelete = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [mobileNumber, setMobileNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [isDeleted, setIsDeleted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [user_id, setuser_id] = useState("");
    console.log(user_id)
    const handleSendOtp = async () => {
        if (!/^[6-9]\d{9}$/.test(mobileNumber)) {
            toast("Enter a valid mobile number");
            return;
        }
        setLoading(true);
        sendOTPForDelete(mobileNumber)
            .then((res) => {
                toast(res.data.message);
                setStep(2);
                setTimeout(() => { }, 5000);
            })
            .catch((err) => {
                toast(err.response?.data?.error);
                setTimeout(() => { }, 5000);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleVerifyOtp = async () => {
        if (!otp) {
            alert("Enter the OTP");
            return;
        }
        setLoading(true);
        verifyOTPForDelete(mobileNumber, otp)
            .then((res) => {
                setuser_id(res.data.data._id);
                if (res) {
                    toast(res.data.message);
                    setTimeout(() => { }, 5000);
                    setStep(3);
                } else {
                    toast(res.message || "Invalid OTP");
                }
            })
            .catch((err) => {
                toast(err.response?.data?.error);
                setTimeout(() => { }, 5000);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleDeleteAccount = async () => {
        setLoading(true);
        deleteAccount(user_id)
            .then((res) => {

                if (res.data.success) {
                    toast(res.data.message);
                    setIsDeleted(true);
                    setTimeout(() => {
                        navigate('/')
                    }, 2000);
                } else {
                    toast(res.message || "Failed to delete account");
                }
            })
            .catch((err) => {
                toast(err.response?.data?.error);
                setTimeout(() => { }, 5000);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="min-h-screen bg-gray-100 text-gray-800 flex items-center justify-center p-4">
            < ToastContainer />
            <div className="w-full max-w-2xl text-center bg-white shadow-md rounded-lg p-6">
                <p className="text-3xl font-bold mb-6">Delete Account</p>

                {/* Step Indicator */}
                <div className="flex flex-col md:flex-row items-center justify-between mb-8">
                    <div className="flex flex-col items-center flex-1">
                        <div
                            className={`w-10 h-10 rounded-full flex items-center justify-center font-bold mb-2 transition ${step >= 1 ? "bg-blue-600 text-white" : "bg-gray-300 text-gray-600"
                                }`}
                        >
                            1
                        </div>
                        <p>Enter Mobile</p>
                    </div>

                    <div
                        className={`${step >= 2 ? "bg-blue-600" : "bg-gray-300"
                            } h-0.5 w-full md:w-auto md:h-0.5 md:flex-1 md:mx-4 my-4 md:my-0 transition`}
                    ></div>

                    <div className="flex flex-col items-center flex-1">
                        <div
                            className={`w-10 h-10 rounded-full flex items-center justify-center font-bold mb-2 transition ${step >= 2 ? "bg-blue-600 text-white" : "bg-gray-300 text-gray-600"
                                }`}
                        >
                            2
                        </div>
                        <p>Verify OTP</p>
                    </div>

                    <div
                        className={`${step === 3 ? "bg-blue-600" : "bg-gray-300"
                            } h-0.5 w-full md:w-auto md:h-0.5 md:flex-1 md:mx-4 my-4 md:my-0 transition`}
                    ></div>

                    <div className="flex flex-col items-center flex-1">
                        <div
                            className={`w-10 h-10 rounded-full flex items-center justify-center font-bold mb-2 transition ${step === 3 ? "bg-blue-600 text-white" : "bg-gray-300 text-gray-600"
                                }`}
                        >
                            3
                        </div>
                        <p>Delete Account</p>
                    </div>
                </div>

                {/* Form Steps */}
                {!isDeleted ? (
                    <div className="mt-6">
                        {step === 1 && (
                            <>
                                <h2 className="text-xl font-semibold mb-4">
                                    Enter Mobile Number
                                </h2>
                                <input
                                    type="text"
                                    placeholder="Enter your mobile number"
                                    value={mobileNumber}
                                    onChange={(e) => setMobileNumber(e.target.value)}
                                    className="w-full p-3 mb-4 text-base border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                                <button
                                    className="w-full bg-blue-600 text-white py-3 rounded-md hover:bg-blue-700 transition"
                                    onClick={handleSendOtp}
                                    disabled={loading}
                                >
                                    {loading ? "Sending OTP..." : "Send OTP"}
                                </button>
                            </>
                        )}

                        {step === 2 && (
                            <>
                                <h2 className="text-xl font-semibold mb-4">Verify OTP</h2>
                                <input
                                    type="text"
                                    placeholder="Enter OTP"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    className="w-full p-3 mb-4 text-base border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                                <button
                                    className="w-full bg-blue-600 text-white py-3 rounded-md hover:bg-blue-700 transition"
                                    onClick={handleVerifyOtp}
                                    disabled={loading}
                                >
                                    {loading ? "Verifying..." : "Verify OTP"}
                                </button>
                            </>
                        )}

                        {step === 3 && (
                            <>
                                <h2 className="text-xl font-semibold mb-4">
                                    Are you sure you want to delete your account?
                                </h2>
                                <button
                                    className="w-full bg-red-600 text-white py-3 rounded-md hover:bg-red-700 transition"
                                    onClick={handleDeleteAccount}
                                    disabled={loading}
                                >
                                    {loading ? "Deleting..." : "Delete Account"}
                                </button>
                            </>
                        )}
                    </div>
                ) : (
                    <div className="mt-12">
                        <h2 className="text-2xl text-green-600 font-semibold">
                            Your account has been successfully deleted!
                        </h2>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AccountDelete;
